import React, { useEffect } from 'react';

import {
  createSportsbookState,
  isUrlNamesMatch,
  SiteConfigManager,
  SportsbookProvider,
  useSportsbookState,
} from '@atlas/core';
import { HeaderTitle, Icon, SportItemsSkeleton } from '@atlas/ui';

import { useSimplifiedSportsbook } from 'common/SimplifiedSportsbook/SimplifiedSportsbookContext';
import useOnScreen from 'common/utils/useOnScreen';
import SportsbookMaintenanceContainer from 'components/MaintenanceContainer/SportsbookMaintenanceContainer';

import MenuSportLink from './MenuSportLink';

const MenuSportsList = () => {
  const { initialized, loading, sports } = useSportsbookState();
  const { setSportName, sportName } = useSimplifiedSportsbook();
  const activeSport = React.useRef(null);
  const isVisible = useOnScreen(activeSport);
  const isVisibleRef = React.useRef(isVisible);

  useEffect(() => {
    if (!sportName && sports.length !== 0) {
      setSportName(sports[0].urlName);
    }
  }, [sports]);

  useEffect(() => {
    if (initialized && activeSport.current && !isVisibleRef.current) {
      activeSport?.current?.scrollIntoView({
        block: 'nearest',
        inline: 'center',
      });
    }
  }, [initialized]);

  if (!initialized && loading) {
    return (
      <div className="menu-sports-list-container">
        <div className="title-wrapper">
          <HeaderTitle className="header-title sub-text block-small" title="sports" />
        </div>
        <div className="sports-list sport-type-skeleton">
          <SportItemsSkeleton isMobile />
        </div>
      </div>
    );
  }

  if (sports.length === 0) {
    return null;
  }

  return (
    <div className="menu-sports-list-container">
      <div className="title-wrapper">
        <HeaderTitle className="sub-text" title="sports" />
      </div>
      <div className="sports-list">
        {sports.map(sport => {
          const { id, name, totalCount, urlName } = sport;
          const isActive = isUrlNamesMatch(urlName, sportName);

          return (
            <div className="sports-item-wrapper" key={id} ref={isActive ? activeSport : null}>
              <MenuSportLink active={isActive} className="sports-item" sportUrlName={urlName}>
                <div className="sports-item-icon">
                  <Icon alt={name} height={32} name={`sportIcon-${id}`} type="sports" width={32} />
                  <span className="sports-item-counter">{totalCount}</span>
                </div>
                <span className="sports-item-name" >{name}</span>
              </MenuSportLink>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const MenuSportsListView = () => {
  const isSimplifiedView = SiteConfigManager.getConfig(
    'config.config.sportsbook.mobileGridViewType',
  );

  if (isSimplifiedView !== 'simplified') return null;

  const sportbookState = createSportsbookState({
    id: 'menu',
    sportServices: ['PREMATCH', 'LIVE'],
  });

  return (
    <SportsbookMaintenanceContainer>
      <SportsbookProvider value={sportbookState}>
        <MenuSportsList />
      </SportsbookProvider>
    </SportsbookMaintenanceContainer>
  );
};

export default MenuSportsListView;
